module.exports = __webpack_public_path__ + "static/media/check.086f98b3.svg";